import React from "react";

const HomeButton = () => {
  return (
    <nav>
      <a href="#home">
        <i class="fas fa-chevron-up home-button"></i>
      </a>
    </nav>
  );
};

export default HomeButton;
